export default values => ({
  distributor: values.distributor || '',
  distributorEquipment: values.distributorEquipment || '',
  price: values.price || '',
  iva: values.iva || 16,
  moreInfo: values.moreInfo || ''
});
